module.exports = __webpack_public_path__ + "static/media/Inter-Regular.80709976.woff2";